export const TranscriptsStatus = {
    Processing: "processing",
    Done: "done",
    Failed: "processing_failed",
};
export const TranscriptsFailureReason = {
    None: "None",
    LimitReached: "LimitReached",
    InvalidVoice: "InvalidVoice",
    FileTooShort: "FileTooShort",
    BrokenAudio: "BrokenAudio",
};
